const settings = {
  pageTitle: "Systemeinstellungen",
  groups: {
    personsAndAccess: "Personen & Zugänge",
    communication: "Kommunikation",
    masterData: "Stammdaten",
    configuration: "Konfiguration",
  },
  tabs: {
    dropdowns: "Dropdowns",
    smsTemplates: "SMS-Vorlagen",
    emailTemplates: "E-Mail-Vorlagen",
    caseNoteTemplates: "Aktenvermerk-Vorlagen",
    banners: "Wartungsbanner",
    proceedingParticipants: "Verfahrensbeteiligte",
    systemRelevantDropdowns: "Systemrelevante Dropdowns",
    volunteers: "Ehrenamtliche Mitarbeiter:innen",
    translationTool: "Übersetzungstool",
    mailMerge: "Serienbrief Datenquelle Ordner",
    addresses: "Adressen-Import",
    holidays: "Feiertage",
    parameters: "Parameter",
    amsParameters: "AMS-Parameter",
    courts: "Gerichte",
    counselors: "Bearbeiter:innen",
  },
  dropdowns: {
    selectDropdown: "Dropdown wählen",
    valueList: "Werteliste",
    addValue: "Wert hinzufügen",
    valuePlaceholder: "Wert",
    deleteEntry: "Eintrag entfernen",
    restoreEntry: "Wiederherstellen",
    saveSuccess: "Änderungen gespeichert",
    saveError: "Einige Änderungen konnten nicht gespeichert werden",
    forbidden: "Sie haben keine Berechtigung, diese Seite zu öffnen.",
    discardOnCategorySwitchTitle: "Änderungen verwerfen?",
    discardOnCategorySwitchText: "Es gibt ungespeicherte Änderungen. Beim Wechsel des Dropdowns gehen sie verloren.",
    duplicateValue: "Wert existiert bereits",
    valueRequired: "Wert darf nicht leer sein",
    categories: {
      Salutation: "Anrede",
      Title: "Titel",
      Citizenship: "Staatsbürgerschaft",
      MediaInquiry: "Medienanfrage",
      ContactSource: "Kontaktquelle",
      Country: "Land",
      City: "Ort",
      EmploymentStatus: "Arbeitssituation",
      AssignmentPriority: "Aufgabepriorität",
      CaseNoteLocation: "Ort (Aktenvermerk)",
      AppointmentLocation: "Terminort",
      CaseNoteResult: "Ergebnis (Aktenvermerk)",
      Qualification: "Qualifikation",
      MaritalStatus: "Familienstand",
      LivingSituation: "Wohnsituation",
      ClientGoalAndResult: "Ziel / Ergebnis",
      ClientMeasures: "Massnahmen",
      ClientCauses: "Ursachen",
      ClaimLegalBasis: "Rechtsgrund (Forderung)",
      Team: "Team",
      WorkArea: "Tätigkeit (Dienstplan)",
      Recommendation: "Empfehlung",
      RegisteredBy: "Anmeldung durch",
      SrvCounselingType: "Beratungsart (Verfahren)",
      SrvCourseEntryResult: "Ergebnis (Verfahrensverlauf)",
      IdentityDocumentType: "Ausweisart",
    },
  },
  templates: {
    selectTemplate: "SMS-Vorlage wählen",
    addTemplate: "Neue SMS-Vorlage",
    title: "Titel",
    content: "Inhalt",
    saveSuccess: "SMS-Vorlage gespeichert",
    saveError: "SMS-Vorlage konnte nicht gespeichert werden",
    createSuccess: "SMS-Vorlage erstellt",
    createError: "SMS-Vorlage konnte nicht erstellt werden",
    deleteSuccess: "SMS-Vorlage gelöscht",
    deleteError: "SMS-Vorlage konnte nicht gelöscht werden",
    deleteConfirmTitle: "SMS-Vorlage löschen?",
    deleteConfirmText: "Diese SMS-Vorlage wird dauerhaft gelöscht.",
    noTemplateSelected: "Keine SMS-Vorlage ausgewählt",
    noTemplates: "Keine SMS-Vorlagen vorhanden",
    placeholderPanel: {
      title: "Verfügbare Platzhalter",
      headerHint:
        "Platzhalter werden beim Erstellen des Texts automatisch durch die Daten des aktuellen Falls ersetzt. Zum Einfügen anklicken.",
      insertTip: "Tipp: Platzhalter in der Referenz anklicken, um sie an der Cursor-Position einzufügen.",
      footerInfo:
        "Hat ein Platzhalter im konkreten Fall keinen Wert, bleibt er unverändert im Text stehen. Der Text kann nach dem Einsetzen noch bearbeitet werden.",
      fixedChip: "FIX",
      examplePrefix: "Beispiel:",
      // Keyed by the placeholder token name (see TemplateManagement.placeholders.ts).
      items: {
        KundennameInklusiveAnrede: {
          label: "Kund:innen-Name inkl. Anrede",
          description: "Anrede, Vor- und Familienname der Kund:in",
          example: "Frau Hofer",
        },
        Kundenadresse: {
          label: "Kund:innen-Adresse",
          description: "Adresse der Kund:in (Straße, Hausnummer, PLZ, Ort)",
          example: "Musterstraße 1, 1100 Wien",
        },
        BeraterinnenName: {
          label: "Berater:innen-Name",
          description: "Name der zugewiesenen Berater:in",
          example: "Lena Wagner",
        },
        BeraterDurchwahl: {
          label: "Berater:innen Durchwahl",
          description: "Durchwahl der zugewiesenen Berater:in",
          example: "60123",
        },
        AllgemeineDurchwahl: {
          label: "Allgemeine Durchwahl",
          description: "Allgemeine Durchwahl — fix im System hinterlegt",
          example: "60100",
        },
        Termin: {
          label: "Termin",
          description: "Gebuchter Termin (auch für stornierten Termin)",
          example: "Mi, 15.07. um 10:00",
        },
        TerminAlt: {
          label: "Alter Termin",
          description: "Bisheriger Termin bei einer Verschiebung",
          example: "So, 12.07. um 09:00",
        },
        TerminNeu: {
          label: "Neuer Termin",
          description: "Neuer Termin bei einer Verschiebung",
          example: "Sa, 18.07. um 14:00",
        },
        Link: {
          label: "Link",
          description: "Einwilligung oder Dokumenten-Upload",
          example: "https://…",
        },
        Terminlink: {
          label: "Terminlink",
          description:
            "Link zur Terminverwaltung im Anmeldeformular (Termin ansehen, absagen, verschieben) — nur bei der automatischen Terminbestätigung befüllt",
          example: "https://…",
        },
        "1BFragebogenlink": {
          label: "1B-Fragebogen-Link",
          description: "Link zum 1B-Fragebogen der Kund:in — nur beim automatischen Versand vor dem 1B-Termin befüllt",
          example: "https://…",
        },
        Registrierungslink: {
          label: "Registrierungslink",
          description:
            "Registrierungslink der Kund:innen-Zugang-Einladung — nur beim automatischen Einladungsversand befüllt",
          example: "https://…",
        },
        PasswortResetLink: {
          label: "Passwort-Reset-Link",
          description: "Link zum Setzen eines neuen Portal-Passworts — nur beim automatischen Versand befüllt",
          example: "https://…",
        },
      },
    },
  },
  caseNoteTemplates: {
    selectTemplate: "Vorlage wählen",
    addTemplate: "Neue Vorlage",
    title: "Titel",
    content: "Inhalt",
    saveSuccess: "Vorlage gespeichert",
    saveError: "Vorlage konnte nicht gespeichert werden",
    createSuccess: "Vorlage erstellt",
    createError: "Vorlage konnte nicht erstellt werden",
    deleteSuccess: "Vorlage gelöscht",
    deleteError: "Vorlage konnte nicht gelöscht werden",
    deleteConfirmTitle: "Vorlage löschen?",
    deleteConfirmText: "Diese Vorlage wird dauerhaft gelöscht.",
    noTemplateSelected: "Keine Vorlage ausgewählt",
    noTemplates: "Keine Vorlagen vorhanden",
  },
  emailTemplates: {
    selectTemplate: "E-Mail-Vorlage wählen",
    addTemplate: "Neue E-Mail-Vorlage",
    title: "Bezeichnung",
    subject: "Betreff",
    content: "Inhalt",
    saveSuccess: "E-Mail-Vorlage gespeichert",
    saveError: "E-Mail-Vorlage konnte nicht gespeichert werden",
    createSuccess: "E-Mail-Vorlage erstellt",
    createError: "E-Mail-Vorlage konnte nicht erstellt werden",
    deleteSuccess: "E-Mail-Vorlage gelöscht",
    deleteError: "E-Mail-Vorlage konnte nicht gelöscht werden",
    deleteConfirmTitle: "E-Mail-Vorlage löschen?",
    deleteConfirmText: "Diese E-Mail-Vorlage wird dauerhaft gelöscht.",
    noTemplateSelected: "Keine E-Mail-Vorlage ausgewählt",
    noTemplates: "Keine E-Mail-Vorlagen vorhanden",
  },
  parameters: {
    selectParameter: "Parameter wählen",
    key: "Schlüssel",
    value: "Wert",
    effectiveFrom: "Gültig ab",
    values: "Werte",
    active: "Aktiv",
    future: "Zukünftig",
    addValue: "Wert hinzufügen",
    deleteValue: "Wert löschen",
    removeNewValue: "Neuen Wert entfernen",
    deleteDisabledWhileDirty: "Bitte zuerst speichern oder die Änderungen zurücksetzen",
    deleteConfirmTitle: "Wert löschen?",
    deleteConfirmText: "Der Wert {{value}} gültig ab {{date}} wird gelöscht.",
    deleteSuccess: "Wert gelöscht",
    noParameterSelected: "Kein Parameter ausgewählt",
    noEntries: "Noch keine Werte erfasst",
    saveSuccess: "Parameter gespeichert",
    saveError: "Parameter konnte nicht gespeichert werden",
    names: {
      SockelbetragEK: "Sockelbetrag EK",
      HoechstbetragEK: "Höchstbetrag EK",
      SockelbetragAMS: "Sockelbetrag AMS",
      Steigerungsbetrag: "Steigerungsbetrag",
      ProzentU: "Prozentuale Reduktion Unterhalt",
      ProzentErw: "Prozentuale Reduktion Erwachsene",
    },
    validation: {
      notNegative: "Der Wert darf nicht negativ sein",
      maxDecimals: "Maximal 2 Nachkommastellen erlaubt",
      percentageRange: "Der Prozentwert muss zwischen 0 und 100 liegen",
      hoechstBelowSockelEK: "Höchstbetrag EK muss größer oder gleich Sockelbetrag EK sein",
      hoechstBelowSockelAMS: "Höchstbetrag EK muss größer oder gleich Sockelbetrag AMS sein",
      effectiveFromInPast: "Das Datum darf nicht in der Vergangenheit liegen",
      duplicateEffectiveFrom: "Für dieses Datum gibt es bereits einen Wert",
    },
  },
  amsParameters: {
    title: "AMS-Parameter",
    description: "Diese Parameter werden systemweit für die AMS-Anbindung verwendet.",
    sid: "SID",
    mappingSection: "VID je Postleitzahl",
    zipCode: "PLZ",
    vid: "VID",
    addMapping: "Zuordnung hinzufügen",
    removeMapping: "Zuordnung entfernen",
    noMappings: "Noch keine Zuordnungen vorhanden.",
    saveSuccess: "AMS-Parameter gespeichert",
    validation: {
      zipCodeInvalid: "PLZ darf nur Ziffern enthalten",
      zipCodeUnique: "Jede PLZ darf nur einmal zugeordnet werden",
      vidUnique: "Jede VID darf nur einer PLZ zugeordnet werden",
    },
  },
  systemDropdowns: {
    info: "Systemrelevante Werte können nicht gelöscht, sondern nur <strong>ausgeblendet</strong> werden. Ein ausgeblendeter Wert wird nicht mehr zur Auswahl angeboten, bleibt aber dort sichtbar, wo er bereits gespeichert ist.",
    selectDropdown: "Dropdown wählen",
    valueList: "Werteliste",
    addValue: "Wert hinzufügen",
    valuePlaceholder: "Wert",
    valueLabel: "Wert {{position}}",
    valueRequired: "Bitte einen Wert eingeben",
    additionalParameters: "Zusätzliche Parameter",
    toggleParameters: "Zusätzliche Parameter für {{value}} ein-/ausblenden",
    hideOption: "{{value}} ausblenden",
    showOption: "{{value}} einblenden",
    saveSuccess: "Änderungen gespeichert",
    saveError: "Einige Änderungen konnten nicht gespeichert werden",
    categories: {
      appointmentPurpose: "Termin-Zwecke",
      attendancePurpose: "Anwesenheits-Zwecke",
      caseNoteType: "Art (Aktenvermerk)",
      clientStatus: "Status (Kundenakt)",
      claimBalanceEntryType: "Typ (Saldo-Eintrag)",
      srvCourseEntryType: "Typ (Verfahrensverlauf)",
      incomeType: "Einkommensart (Vermögensverzeichnis)",
    },
    parameters: {
      overbookable: "Überbuchbar",
      attendanceType: "Anwesenheitstyp",
      deletable: "Löschbar",
      editable: "Bearbeitbar",
      srvRegistered: "SRV-Anmeldung",
      projected: "Hochrechnung",
      incomeTreatment: "Merkmal",
      availableInExchange: "In Tauschbörse verfügbar",
      conversation: "Gespräch",
    },
    parameterValues: {
      present: "Anwesend",
      absent: "Abwesend",
      incomeStandard: "Standard",
      incomeNonSeizable: "Unpfändbar",
      incomeDailyRate: "Tagsatz",
      incomeSpecialPaymentsExpected: "Sonderzahlungen üblich",
    },
  },
  banner: {
    maintenanceNotice: "Achtung! Geplante Wartung vom {{startDate}} ab {{startTime}}",
    configuration: {
      title: "Wartungsbanner",
      bannerStart: "Banner-Anzeige ab",
      maintenanceStart: "Wartungsbeginn",
      maintenanceEnd: "Wartungsende",
      message: "Nachricht",
      messagePlaceholder: "Optionale Nachricht für den Banner",
      save: "Speichern",
      deactivate: "Deaktivieren",
      saveSuccess: "Wartungsbanner wurde erfolgreich konfiguriert.",
      deactivateSuccess: "Wartungsbanner wurde deaktiviert.",
      noBannerConfigured: "Kein Wartungsbanner konfiguriert.",
      validation: {
        maintenanceEndBeforeStart: "Wartungsende muss nach Wartungsbeginn liegen.",
        bannerStartAfterMaintenance: "Banner-Anzeige muss vor Wartungsbeginn liegen.",
        maintenanceStartInPast: "Wartungsbeginn darf nicht in der Vergangenheit liegen.",
      },
    },
  },
  translationTool: {
    title: "Übersetzungstool",
    url: "URL",
    saveSuccess: "Übersetzungstool-URL wurde gespeichert.",
    invalidUrl: "Die URL muss eine vollständige http(s)-Adresse sein.",
  },
  mailMerge: {
    dataSourceFolder: "Datenquelle Ordner",
    description:
      "Die Word-Serienbrief-Hauptdokumente verweisen auf einen fest hinterlegten Ordner am Gerät. SONeu schreibt die Datenquellen in genau diesen Ordner. Hier wird der <bold>Ordnerpfad</bold> hinterlegt — er gilt für alle Nutzer:innen. Die Freigabe des Ordners erfolgt einmalig pro Gerät und Browserprofil durch die Mitarbeiter:innen selbst.",
    saveSuccess: "Serienbrief-Ordner wurde gespeichert.",
    invalidFolderPath:
      'Der Pfad muss auf einen gültigen Ordnernamen enden — ohne : * ? " < > | und ohne Punkt am Ende.',
  },
  addresses: {
    title: "Wiener Adressen",
    importButton: "Import starten",
    importing: "Importiere...",
    importStarted: "Adressimport wurde gestartet. Der Vorgang läuft im Hintergrund.",
    importAlreadyRunning: "Es läuft bereits ein Adressimport. Bitte warten Sie, bis dieser abgeschlossen ist.",
    importError: "Fehler beim Starten des Adressimports.",
    lastImport: "Letzter Import: {{date}}",
    neverImported: "Noch kein Import durchgeführt.",
  },
  holidays: {
    title: "Österreichische Feiertage",
    description:
      "Laden Sie die österreichischen Feiertage für einen Jahresbereich. Es können nur das aktuelle und zukünftige Jahre importiert werden.",
    fromYear: "Von Jahr",
    tillYear: "Bis Jahr",
    importButton: "Feiertage laden",
    importing: "Importiere...",
    importSuccess: "Feiertage wurden erfolgreich importiert.",
    importSuccessWithSkipped: "Feiertage importiert. Für folgende Jahre waren keine Daten verfügbar: {{years}}.",
    table: {
      date: "Datum",
      weekday: "Wochentag",
      name: "Bezeichnung",
      type: "Art",
    },
    kind: {
      publicHoliday: "Feiertag",
      dienstfrei: "Dienstfrei",
    },
    empty: "Es wurden noch keine Feiertage importiert.",
  },
  courts: {
    count_one: "{{count}} Bezirksgericht",
    count_other: "{{count}} Bezirksgerichte",
    addButton: "Gericht hinzufügen",
    empty: "Es wurden noch keine Gerichte erfasst.",
    successfullyCreated: "Gericht angelegt",
    successfullyUpdated: "Gericht gespeichert",
    successfullyDeleted: "Gericht gelöscht",
    saveFailed: "Das Gericht konnte nicht gespeichert werden.",
    districtAlreadyAssigned: "Mindestens ein Bezirk ist bereits einem anderen Gericht zugeordnet.",
    deleteConfirmTitle: "Gericht löschen?",
    deleteConfirmText:
      "Möchten Sie das Gericht „{{name}}“ wirklich löschen? Bereits im Kalender eingetragene Tagsatzungen bleiben erhalten.",
    create: {
      dialogTitle: "Gericht hinzufügen",
    },
    edit: {
      dialogTitle: "{{name}} · Gerichtstage",
    },
    form: {
      name: "Bezeichnung",
      shortCode: "Kürzel",
      fileNumberPrefix: "Aktenzeichen Präfix",
      districts: "Sprengel / Bezirke",
      districtOption: "{{code}} · {{number}}. Bezirk",
      zipCodeInvalid: "Die PLZ muss aus 4 Ziffern bestehen.",
      fileNumberPrefixInvalid: "Das Aktenzeichen Präfix muss aus genau 3 Ziffern bestehen.",
      fileNumberPrefixAlreadyInUse: "Dieses Aktenzeichen Präfix wird bereits von einem anderen Gericht verwendet.",
    },
    gerichtstag: {
      sectionTitle: "Gerichtstage",
      add: "Gerichtstag hinzufügen",
      empty: "Keine Gerichtstage definiert",
      type: "Typ",
      types: {
        weekday: "Wochentag",
        rule: "Regel",
        singleDates: "Einzeltermine",
      },
      rule: "Regel",
      weekday: "Wochentag",
      ordinals: {
        First: "erster",
        Second: "zweiter",
        Third: "dritter",
        Last: "letzter",
      },
      weekdays: {
        Monday: "Montag",
        Tuesday: "Dienstag",
        Wednesday: "Mittwoch",
        Thursday: "Donnerstag",
        Friday: "Freitag",
      },
      perMonth: "im Monat",
      singleDates: "Einzeltermine",
      date: "Termin",
      dateCount: "{{count}} Termine",
      addDate: "Termin",
      removeDate: "Termin entfernen",
      remove: "Gerichtstag entfernen",
    },
    card: {
      address: "Adresse: {{address}}",
      districts: "Bezirke: {{districts}}",
      noGerichtstage: "Keine Gerichtstage definiert",
      editAria: "Gericht „{{name}}“ bearbeiten",
      deleteAria: "Gericht „{{name}}“ löschen",
    },
    chip: {
      weekdaysShort: {
        Monday: "Mo",
        Tuesday: "Di",
        Wednesday: "Mi",
        Thursday: "Do",
        Friday: "Fr",
      },
      ordinalsShort: {
        First: "1.",
        Second: "2.",
        Third: "3.",
        Last: "letzter",
      },
      rule: "{{ordinal}} {{weekday}}/Monat",
      singleDate: "Einzeltermin: {{date}}",
      singleDatesSummary: "{{count}} Einzeltermine · {{dates}}",
    },
  },
};

export default settings;
